import React from 'react'
import PropTypes from 'prop-types'

class FlywheelLoader extends React.Component {
	render() {
		const { message } = this.props
		return <div className="fw">
			<div className="text-center tall">
				<img src="/assets/animated-loading-spinner.svg" alt=""/>
				<h1 className="text-blue">{message || "Loading"}
					<span className="loading-dot">.</span>
					<span className="loading-dot">.</span>
					<span className="loading-dot">.</span>
				</h1>
			</div>
		</div>
	}
}

FlywheelLoader.propTypes = {
	message: PropTypes.string
}

export default FlywheelLoader
